import type { ComponentProps } from 'react';
import React from 'react';
import { Button } from '@lt/components';
import type { MailConfirmationForm } from 'src/components/AuthNew/components/MailConfirmationForm';
import { useTranslation } from '@lt/localization';
import { Content, Description, Title } from './styles';

type Props = ComponentProps<typeof MailConfirmationForm>;

export const RegistrationMailConfirmation = ({
  onClose,
  emailIsConfirmed,
}: Props) => {
  const { t } = useTranslation();
  return (
    <>
      <Title>{t('checkout.mail.registration.title')}</Title>
      <Description>{t('checkout.mail.registration.description')}</Description>
      {!emailIsConfirmed && (
        <Description>
          {t('checkout.mail.registration.confirmation')}
        </Description>
      )}

      <Content>
        <Button size="flex" type="submit" primary onClick={onClose}>
          {t('checkout.updateForm.footer')}
        </Button>
      </Content>
    </>
  );
};
